import template from './admin-hotel-edit.html';
import suppliers from './../../supplier/suppliers';

const DIRECTIVE_NAME = AdminHotelEdit.DIRECTIVE_NAME = 'ktAdminHotelEdit';
export default function AdminHotelEdit() {
    return {
        restrict: 'A',
        controller: AdminHotelEditController,
        controllerAs: 'adminHotelEditCtrl',
        template,
        bindToController: true,
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, adminHotelEditCtrl) {
            adminHotelEditCtrl.$onInit();
        },
    };
}

export function AdminHotelEditController(
    adminHotelListService
) {
    'ngInject';
        const vm = this;
        const MANUAL_FIELD = {
            supplier: null,
            isSelected: true,
            fieldValue: '',
            hasSupplier: false,
        };
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let originalHotel;

        Object.assign(vm, {
            $onInit,
            addManual,
            hasManual,
            removeManual,
            emailRegex,
            getSupplierLogo: adminHotelListService.getSupplierLogo,
        });

        function $onInit() {
            originalHotel = angular.copy(vm.hotel);
        }

        function addManual(fieldName) {
            const options = vm.hotel[fieldName];
            options.forEach((item) => item.isSelected = false);
            vm.hotel[fieldName] = [
                ...options,
                angular.copy(MANUAL_FIELD),
            ];
        }

        function hasManual(fieldName) {
            return vm.hotel[fieldName].some(isManualInput);
        }

        function removeManual(field) {
            const optionsWithoutManual = getOriginalOptions().filter(isNotManualInput);
            const isSupplierWasSelected = optionsWithoutManual.some(({isSelected}) => isSelected);

            if (isSupplierWasSelected) {
                setOptions(originalHotel[field]);
                return;
            }

            const sortedSuppliers = Object.values(suppliers)
                .sort((first, second) => first.priority - second.priority);

            optionsWithoutManual.forEach((value) => value.isSelected = false);
            sortedSuppliers.some(({id}) => {
                const higherPriority = optionsWithoutManual.find(({supplier}) => supplier === id);

                if (higherPriority) {
                    higherPriority.isSelected = true;
                }
                return higherPriority && higherPriority.isSelected;
            });

            setOptions(optionsWithoutManual);

            function getOriginalOptions() {
                return originalHotel[field];
            }

            function setOptions(value) {
                vm.hotel[field] = value;
            }
        }

        function isManualInput(option) {
            return option && option.supplier === null;
        }

        function isNotManualInput(option) {
            return !isManualInput(option);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-component.js